var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 13.1856C1.38889 13.2967 1.125 13.2723 0.875 13.1123C0.625 12.9529 0.5 12.7204 0.5 12.4148V9.31063C0.5 9.11619 0.555556 8.94258 0.666667 8.7898C0.777778 8.63702 0.930556 8.5398 1.125 8.49813L7.16667 6.99813L1.125 5.49813C0.930556 5.45647 0.777778 5.35924 0.666667 5.20647C0.555556 5.05369 0.5 4.88008 0.5 4.68563V1.58147C0.5 1.27591 0.625 1.04313 0.875 0.883134C1.125 0.72369 1.38889 0.699523 1.66667 0.810634L14.5 6.2273C14.8472 6.38008 15.0208 6.63702 15.0208 6.99813C15.0208 7.35924 14.8472 7.61619 14.5 7.76897L1.66667 13.1856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.03d5fa577d8a306273ec9b7958a0662f.svg";
export { ForwardRef as ReactComponent };